import _ from 'lodash';
import api from 'networkapp-api-connector';
import moment from 'moment';

export default {
    fetchEventQuestions: function (eventId, loadAnswers) {
        return api.questions.fetchEventQuestions(eventId, loadAnswers).then(answer => {
            app.store.dispatch(app.actions.questions.loadEventQuestions(eventId, answer.result, answer.deleted, moment.utc(answer.fetch_time).toISOString()));
        });
    },
    /**
     * Posts a new questions
     * @param  int      eventId
     * @param  string   content     Question text
     * @param  boolean  anonymous   Whether the question will be shown as anonymous to other users
     * @param  int      categoryId  (OPTIONAL) Group question_category_id to include the question
     * @param  array    attachments (OPTIONAL) List of attachments GUIDs to link to the question
     * @return Promise
     */
    postQuestion: function (eventId, content, anonymous, categoryId, attachments) {
        let askerId = app.store.getState().session.user.id,
            categoryName;

        attachments || (attachments = []);

        if (categoryId) {
            let categories = _.get(app.store.getState(), 'events[' + eventId + '].event.question_categories'),
                category = _(categories).find({id: categoryId});
            if (category) {
                categoryName = category.label;
            }
        }

        return api.questions.postQuestion(eventId, askerId, content, anonymous, categoryId, categoryName, attachments).then(data => {
            if (categoryId) {
                // The api doesn't return this field here, but we know the value
                Object.assign(data, {category_id: categoryId});
            }
            app.store.dispatch(app.actions.questions.add(eventId, data));
        });
    },
    updateQuestion: function (eventId, questionId, content, anonymous, attachments) {
        return api.questions.updateQuestion(eventId, questionId, content, anonymous, attachments).then(data => {
            app.store.dispatch(app.actions.questions.update(eventId, questionId, data, data.lastModified));
        });
    },
    deleteQuestion: function (eventId, questionId) {
        return api.questions.deleteQuestion(eventId, questionId).then(data => {
            app.store.dispatch(app.actions.questions.delete(eventId, questionId));
            return data;
        });
    },
    postAnswer: function (eventId, questionId, content, anonymous, attachments) {
        return api.questions.postAnswer(questionId, content, anonymous, attachments).then(data => {
            app.store.dispatch(app.actions.questions.addAnswer(eventId, questionId, data));
        });
    },
    updateAnswer: function (eventId, questionId, answerId, content, anonymous, attachments) {
        return api.questions.updateAnswer(questionId, answerId, content, anonymous, attachments).then(data => {
            app.store.dispatch(app.actions.questions.updateAnswer(eventId, questionId, answerId, data));
        });
    },
    deleteAnswer: function (eventId, questionId, answerId) {
        return api.questions
            .deleteAnswer(questionId, answerId)
            .then(data => {
                app.store.dispatch(app.actions.questions.deleteAnswer(eventId, questionId, answerId));
            })
            .catch(() => {});
    },
    fetchAnswers: function (eventId, questionId) {
        return api.questions.fetchAnswers(questionId).then(data => {
            app.store.dispatch(
                app.actions.questions.setAnswers(eventId, questionId, data.result, data.my_answer_count, moment.utc(data.fetch_time).toISOString())
            );
        });
    },
    joinGroup: function (eventId, questionCategoryId) {
        return api.questions.joinGroup(questionCategoryId).then(data => {
            app.store.dispatch(app.actions.events.updateQuestionCategory(eventId, questionCategoryId, data));
        });
    },
    leaveGroup: function (eventId, questionCategoryId) {
        return api.questions.leaveGroup(questionCategoryId).then(data => {
            app.store.dispatch(app.actions.events.updateQuestionCategory(eventId, questionCategoryId, {subscribed: false}));
        });
    },
    favorite: function (eventId, questionId, favorite) {
        return api.questions.favorite(questionId, favorite).then(question => {
            if (question) {
                app.store.dispatch(app.actions.questions.update(eventId, questionId, question));
            }
        });
    },
    markAsRead: function (eventId) {
        return api.questions.markAsRead(eventId).then(data => {
            app.store.dispatch(app.actions.questions.markAsRead(eventId));
        });
    }
};
